document.addEventListener('DOMContentLoaded', function () {
  const blocks = document.querySelectorAll(
    '.brand-concept__text-block'
  );

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.15
    }
  );

  blocks.forEach(function (block) {
    observer.observe(block);
  });
});